import apiEndpoints from '../../apiEndpoints';

// Matches a URI scheme prefix (e.g. "https:", "http:", "ftp:")
const SCHEME_REGEX = /^[a-zA-Z0-9-]+:/;

// Extracts "scheme://host" from an absolute URL (preserves port if present)
const extractSchemeAndHost = (url: string): string | null => {
  try {
    const parsed = new URL(url);
    return `${parsed.protocol}//${parsed.host}`;
  } catch {
    return null;
  }
};

// Resolves final URL from an apiMethod path against apiEndpoints.basePath
// - absolute URL with scheme (https://...) → used as-is
// - root-relative (/...):
//     - basePath is absolute URL → use its scheme+host only, then append path
//     - basePath is not absolute → use path as-is (no prefix)
// - relative path → apiEndpoints.basePath + "/" + path
export const resolveApiPath = (path: string): string => {
  if (SCHEME_REGEX.test(path)) {
    return path;
  }

  if (path.startsWith('/')) {
    const schemeAndHost = extractSchemeAndHost(apiEndpoints.basePath);
    if (schemeAndHost) {
      return `${schemeAndHost}${path}`;
    }
    return path;
  }

  return `${apiEndpoints.basePath}/${path}`;
};
